import React from "react"

export  function HotelSearch() {
    return <h1>Hotels </h1>
}